export const getBackgroundImage = () => {
  const min = 1;
  const max = 25;
  return Math.floor(Math.random() * max) + min;
};
